import { render, staticRenderFns } from "./CompanyFinancialDetails.vue?vue&type=template&id=49154daa&"
import script from "./CompanyFinancialDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyFinancialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports